var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConcierge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.1H3V18.3H3.9V4.80002C3.9 4.56133 3.99482 4.33241 4.1636 4.16363C4.33239 3.99485 4.56131 3.90002 4.8 3.90002H17.4C17.6387 3.90002 17.8676 3.99485 18.0364 4.16363C18.2052 4.33241 18.3 4.56133 18.3 4.80002V9.30002H20.1V18.3H21V20.1ZM16.5 18.3H18.3V11.1H12.9V18.3H14.7V12.9H16.5V18.3ZM16.5 9.30002V5.70002H5.7V18.3H11.1V9.30002H16.5ZM7.5 11.1H9.3V12.9H7.5V11.1ZM7.5 14.7H9.3V16.5H7.5V14.7ZM7.5 7.50002H9.3V9.30002H7.5V7.50002Z",
    fill: "#5C5C5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConcierge);
export default __webpack_public_path__ + "static/media/ic-concierge.43a6948d6124705ce84bdcbf69c5db67.svg";
export { ForwardRef as ReactComponent };